var _title, _g, _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M87.272 401.454c0-48.199 39.073-87.273 87.273-87.273h418.909c48.199 0 87.273 39.074 87.273 87.273v279.272c0 48.199-39.074 87.273-87.273 87.273h-418.909c-48.199 0-87.273-39.074-87.273-87.273v-279.272zM174.545 384c-9.64 0-17.454 7.814-17.454 17.454v279.272c0 9.64 7.814 17.454 17.454 17.454h418.909c9.64 0 17.454-7.814 17.454-17.454v-279.272c0-9.64-7.814-17.454-17.454-17.454h-418.909z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M384 69.818c-77.137 0-139.637 62.515-139.637 139.638v139.635c0 19.28-15.629 34.909-34.909 34.909s-34.91-15.629-34.91-34.909v-139.635c0-115.676 93.752-209.456 209.455-209.456 115.668 0 209.455 93.686 209.455 209.456v139.635c0 19.28-15.629 34.909-34.91 34.909s-34.909-15.629-34.909-34.909v-139.635c0-77.191-62.507-139.638-139.637-139.638z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.76ab9e37.svg";
export { ForwardRef as ReactComponent };